export default "__VITE_ASSET__CheTLF8u__"